/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lucky_Cool_Llama_ClimbInputs */

const fr_lucky_cool_llama_climb = /** @type {(inputs: Lucky_Cool_Llama_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appliquer le thème`)
};

/**

* @param {Lucky_Cool_Llama_ClimbInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const lucky_cool_llama_climb = /** @type {((inputs?: Lucky_Cool_Llama_ClimbInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lucky_Cool_Llama_ClimbInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_lucky_cool_llama_climb(inputs)
});